(function($) {
  "use strict";

  window.zoom = function(event) {
    var zoomFactor = 2;
    var target = event.currentTarget.querySelector('img');
    var rect = target.getBoundingClientRect();
    var offsetX = event.clientX - rect.left;
    var offsetY = event.clientY - rect.top;
    var posX = (offsetX / target.width) * 100;
    var posY = (offsetY / target.height) * 100;

    target.style.transformOrigin = posX + '% ' + posY + '%';
    target.style.transform = 'scale(' + zoomFactor + ')';
    //console.log('Zooming...', event);
  };

  window.resetZoom = function(event) {
    var target = event.currentTarget.querySelector('img');
    target.style.transform = 'scale(1)';
  };

  jQuery(document).ready(function() {
      document.onkeydown = function(e) {
          if (event.keyCode == 123 || e.ctrlKey && e.shiftKey && e.keyCode == 73 || e.ctrlKey && e.shiftKey && e.keyCode == 67 || e.ctrlKey && e.shiftKey && e.keyCode == 74 || e.ctrlKey && e.keyCode == 85)
              return !1;
      };

      $("button.navbar-toggler").click(function() {
          $(".main-menu-area").addClass("active");
          $(".mm-fullscreen-bg").addClass("active");
          $("body").addClass("hidden");
      });
      $(".close-box").click(function() {
          $(".main-menu-area").removeClass("active");
          $(".mm-fullscreen-bg").removeClass("active");
          $("body").removeClass("hidden");
      });
      $(".mm-fullscreen-bg").click(function() {
          $(".main-menu-area").removeClass("active");
          $(".mm-fullscreen-bg").removeClass("active");
          $("body").removeClass("hidden");
      });

      if ($.fn.magnificPopup) {
          $(".product-main-img").magnificPopup({
              delegate: "a",
              type: "image",
              showCloseBtn: !0,
              closeBtnInside: !1,
              midClick: !0,
              tLoading: "Loading image #%curr%...",
              mainClass: "mfp-img-mobile",
              gallery: {
                  enabled: !0,
                  navigateByImgClick: !0,
                  preload: [0, 1]
              },
              image: {
                  tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
              }
          });

          $(".play-button, .popup-vimeo, .popup-gmaps").magnificPopup({
              tClose: "Close (Esc)",
              type: "iframe",
              mainClass: "mfp-fade",
              removalDelay: 160,
              preloader: !1,
              fixedContentPos: !1
          });
      } else {
          console.log("Magnific Popup is not defined");
      }

      $('.zoom').on('mousemove', function(event) {
        zoom(event);
      });

      $('.zoom').on('mouseleave', function(event) {
        resetZoom(event);
      });

      $(window).scroll(function() {
          $(this).scrollTop() > 1000 ? $("#top").fadeIn() : $("#top").fadeOut();
      });
      $("#top").click(function() {
          return $("html, body").animate({ scrollTop: 0 }, 600), !1;
      });
  });
})(jQuery);